import clsx from "clsx";
import * as React from "react";

interface CharacterCountProps extends React.ComponentProps<"p"> {
  size?: "xs" | "sm" | "md" | "lg";
}
const CharacterCount = React.forwardRef<
  HTMLParagraphElement,
  CharacterCountProps
>((props, ref) => {
  const { className, size = "md", ...rest } = props;
  return (
    <p
      ref={ref}
      className={clsx("ox-reset ox-CharacterCount", className)}
      data-size={size}
      {...rest}
    />
  );
});

export { CharacterCount };
export type { CharacterCountProps };
